<template>
  <div>
    <template v-if="content.id">
      <b-img :src="selected.url" alt="" fluid-grow thumbnail rounded />
      <hr />
    </template>
    <b-row align-h="end">
      <b-col cols="auto">
        <b-button variant="primary" v-b-modal="modal"> {{ content.id ? 'Change' : 'Upload' }} image </b-button>

        <b-modal title="Upload Image" :id="modal" hide-footer>
          <image-browser prefix="page" @select="handleSelect" />
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ImageBrowser from '../../../components/ImageBrowser'

export default {
  name: 'PagesImageWidget',
  components: { ImageBrowser },
  props: { value: { type: Object }, resolved: { type: Object } },
  data() {
    return { content: this.value, selected: this.resolved }
  },
  computed: {
    modal() {
      return (
        'image-browser-' +
        Math.random()
          .toString(36)
          .substr(2, 9)
      )
    },
  },
  methods: {
    handleSelect(selected) {
      this.$set(this.content, 'id', selected.id)
      this.selected = selected
      this.$bvModal.hide(this.modal)
    },
  },
}
</script>
